import React from "react";
import ReactApexChart from "react-apexcharts";
import { Spin } from "antd";


const LineChart: React.FC<{ loading: boolean; ordersData: { name: string; data: number[] }[]; categories: string[] }> = ({
  loading,
  ordersData,
  categories,
}) => {
  const options: ApexCharts.ApexOptions = {
    chart: { type: "line",
      toolbar: { show: false },
      zoom: { enabled: false } },
    stroke: { curve: "smooth" },
    xaxis: { categories,
      labels: { style: { fontSize: "14px" } },
      title: { text: "Días",
        style: { fontSize: "16px",
          fontWeight: 600 } } },
    yaxis: [
      { title: { text: "Órdenes",
        style: { fontSize: "16px",
          fontWeight: 600 } },
      labels: { style: { fontSize: "14px" },
        formatter: (val) => val.toString() } },
      { opposite: true,
        title: { text: "Ingresos (MXN)",
          style: { fontSize: "16px",
            fontWeight: 600 } },
        labels: { style: { fontSize: "14px" },
          formatter: (val) => `$${val.toFixed(2)} MXN` } },
    ],
    tooltip: { y: [{ formatter: (val: number) => val.toString() }, { formatter: (val: number) => `$${val.toFixed(2)}` }] },
  };

  const series = [
    { name: "Órdenes",
      data: ordersData[0].data,
      yAxisIndex: 0 },
    { name: "Ingresos",
      data: ordersData[1].data,
      yAxisIndex: 1 },
  ];

  return <>{loading ? <Spin /> : <ReactApexChart options={options} series={series} type="line" height={400} />}</>;
};

export default LineChart;
